<script>
    import Router, { location } from "svelte-spa-router";
    import routes from "./routes/routes.js";
    import { App } from "@capacitor/app";
    import { Toast } from "@capacitor/toast";
    import { onMount, onDestroy } from "svelte";
    import { Toaster } from "svelte-french-toast";
    import { TOAST_DURATION } from "./utiles/common.util.js";

    let backPressedTime = 0;
    let backHandler;

    onMount(() => {
        // 전역 autocomplete="off" 설정 (MutationObserver 사용)
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) {
                        // input 태그 처리
                        if (
                            node.tagName === "INPUT" ||
                            node.tagName === "TEXTAREA"
                        ) {
                            node.setAttribute("autocomplete", "off");
                        }
                        // 하위 요소 중 input 태그 처리
                        node.querySelectorAll("input, textarea").forEach(
                            (input) => {
                                input.setAttribute("autocomplete", "off");
                            },
                        );
                        // form 태그 처리
                        if (node.tagName === "FORM") {
                            node.setAttribute("autocomplete", "off");
                        }
                        node.querySelectorAll("form").forEach((form) => {
                            form.setAttribute("autocomplete", "off");
                        });
                    }
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });

        // 기존 input들 처리
        document.querySelectorAll("input, textarea, form").forEach((el) => {
            if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
                el.setAttribute("autocomplete", "off");
            } else if (el.tagName === "FORM") {
                el.setAttribute("autocomplete", "off");
            }
        });

        backHandler = App.addListener("backButton", async () => {
            if (typeof window.onAppBack === "function") {
                if (window.onAppBack() === true) {
                    return;
                }
            }

            let currentPath = window.location.hash.replace(/^#/, "");

            // 로그인 페이지("/") 또는 메인 메뉴("/Menu")에서 뒤로가기 시 종료 로직 실행
            if (
                currentPath === "/" ||
                currentPath === "" ||
                currentPath === "/Menu"
            ) {
                const now = Date.now();
                if (now - backPressedTime < 2000) {
                    App.exitApp();
                } else {
                    backPressedTime = now;
                    await Toast.show({
                        text: "앱을 종료하려면 한 번 더 눌러주세요",
                        duration: "short",
                    });
                }
            } else {
                // 홈이 아니면 이전 화면으로 이동
                window.history.back();
            }
        });
    });

    onDestroy(() => {
        // 컴포넌트 해제 시 리스너 제거
        if (backHandler) backHandler.remove();
    });
</script>

<div class="app-container">
    <Toaster
        position="bottom-center"
        toastOptions={{
            duration: TOAST_DURATION,
            success: { duration: TOAST_DURATION },
            error: { duration: TOAST_DURATION },
        }}
    />
    <Router {routes} />
</div>
